import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import * as serviceWorker from './serviceWorker';
import 'whatwg-fetch';
import sentryWoker from './sentry'
import { registerApplication, unloadApplication, start, getAppNames } from 'single-spa'
import { pathPrefix, loadResources } from '@code/micro'
import { segmentCompareProps } from './micro'
import containerDataSegmentCompareResources from 'container-data-segment-compare/dist/resource.json'
import { whiteHostsWorker } from './common/whiteHosts';
import './styles/index.less';

export function mount () {

  // 注册数据

  const packageName = 'container-data-segment-compare'

  const o = async () => {
    const p = await loadResources(packageName, containerDataSegmentCompareResources)
    return  p
  }
  console.log( o(), '00000-0--0-0')

  registerApplication(
    packageName, 
    async () => {
      await loadResources(packageName, containerDataSegmentCompareResources)
      return window[packageName]
    }, 
    pathPrefix(segmentCompareProps.rootPath),
    segmentCompareProps
  )

  

  console.log('init app ->')
  
  start()
}

export function unmount () {
  return Promise.all(getAppNames().map(appName => unloadApplication(appName)))
}

whiteHostsWorker();

unmount().then(() => {
  mount()
  // window.addEventListener('DOMContentLoaded', mount)
})

if (process.env.NODE_ENV == 'production') {
	sentryWoker()
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
